import React from 'react';
import { Option } from '../../../types/common/Option';
import SelectField from '../../Forms/Input/SelectField';
import { useProduct } from '../../../hooks/useProduct';

interface ExtendedOption extends Option {
  code?: number;
}

interface Props {
  value: number | null;
  options: ExtendedOption[];
  onChange: (selection: { id: number | null; code: number | null }) => void;
  disabled?: boolean;
}

const ProductItemTypeSelector: React.FC<Props> = ({
  value,
  options,
  onChange,
  disabled = false,
}) => {
  const filteredOptions = options.filter(
    (opt) => opt.code === 1 || opt.code === 2
  );

  const { resetFormOnItemTypeChange, resetErrors, formErrors } = useProduct();

  return (
    <div className="mb-3">
      <h2 className="mb-1 text-lg font-semibold text-black dark:text-white">
        Selecciona el tipo de ítem
      </h2>
      <p className="text-gray-600 dark:text-gray-400 mb-4 text-sm">
        Elige si este registro corresponde a un bien o un servicio. Esto ayudará
        a determinar la estructura de los campos que se mostrarán.
      </p>

      <div className="max-w-md">
        <SelectField
          label="Tipo de Ítem:"
          name="itemTypeId"
          iconKey="list"
          value={value ?? ''}
          onChange={(e) => {
            const raw = e.target.value;
            const parsedId = typeof raw === 'string' ? parseInt(raw) : raw;

            const selected = filteredOptions.find((opt) => opt.id === parsedId);

            if (selected?.id && selected.code != null) {
              resetFormOnItemTypeChange(selected.id, selected.code);
              resetErrors();
            }

            onChange({
              id: selected?.id ?? null,
              code: selected?.code ?? null,
            });
          }}
          options={filteredOptions.map((item) => ({
            value: item.id,
            label: item.name,
          }))}
          placeholder="Seleccione el tipo de ítem"
          error={formErrors.itemTypeId}
          disabled={disabled}
          required
        />
      </div>
    </div>
  );
};

export default ProductItemTypeSelector;
